import { Col, Row, Space, Switch } from "antd";
import React from "react";
import styles from "./preview.module.scss";
import TaxAmount from "./taxAmount";

const DEFAULT_COLUMNS = [
  "S. No.",
  "Item",
  "HSN Code",
  "MRP",
  "Brand",
  "Quantity",
  "Rate",
  "Discount",
  "Amount",
];

const WITH_IMAGE_COLUMNS = [
  "S. No.",
  "Item",
  "Image",
  "HSN Code",
  "MRP",
  "Brand",
  "Quantity",
  "Rate",
  "Discount",
  "Amount",
];

const COL_MAP = {
  "S. No.": "idx",
  Item: "boq_item",
  "HSN Code": "hsn_code",
  Brand: "brand",
  MRP: "mrp",
  Quantity: "quantity",
  Rate: "rate",
  Discount: "discount",
  Amount: "amount",
  Image: "image",
};

export const QuotePreview = ({
  organisationDetails,
  projectDetails,
  user,
  currentGst,
  billTo,
  shipTo,
  dataSource,
  additionalCharges,
  paymentTerms,
  terms,
  branch,
}) => {
  const [visibleColumns, setVisibleColumns] = React.useState(DEFAULT_COLUMNS);
  const [showImage, setShowImage] = React.useState(false);

  React.useEffect(() => {
    if (showImage) {
      setVisibleColumns(WITH_IMAGE_COLUMNS);
    } else {
      setVisibleColumns(DEFAULT_COLUMNS);
    }
  }, [showImage]);

  const generateDetail = React.useCallback(
    (label, value, rightAlignLabel = false) => {
      // if (!value) return null;

      return (
        <Row>
          <Col
            span={7}
            className={styles.label}
            style={{ textAlign: rightAlignLabel ? "right" : "left" }}
          >
            {label}
          </Col>
          <Col span={1}>:</Col>
          <Col span={16} className={styles.value}>
            {value ?? "-"}
          </Col>
        </Row>
      );
    },
    []
  );

  const processedDataSource = React.useMemo(() => {
    console.log("debug>>> datasource", dataSource);
    return dataSource?.map((row, idx) => {
      const rate = parseFloat(
        ((parseFloat(row?.unit_selling_price) +
          (parseFloat(row?.unit_selling_price) * parseFloat(row?.margin) ?? 0) /
            100) *
          (100 + parseFloat(row?.tax_value) ?? 0)) /
          100
      );

      const cost_price = parseFloat(
        parseFloat(row?.unit_selling_price) +
          (parseFloat(row?.unit_selling_price) * parseFloat(row?.margin) ?? 0) /
            100
      )?.toFixed(2);
      var discount =
        (parseFloat(row?.mrp) -
          parseFloat(
            ((parseFloat(row?.unit_selling_price) +
              (parseFloat(row?.unit_selling_price) * parseFloat(row?.margin) ??
                0) /
                100) *
              (100 + parseFloat(row?.tax_value) ?? 0)) /
              100
          )) /
        parseFloat(row?.mrp);
      discount = parseFloat(parseFloat(discount) * 100).toFixed(2);
      return {
        ...row,
        idx: idx + 1,
        quantity: (
          <div>
            {row.quantity}
            <br />
            {/* {row.unit} */}
          </div>
        ),
        quantity_raw: row.quantity,
        rate: (
          <div>
            {rate.toFixed(2)}/
            <br />
            {row.unit}
          </div>
        ),
        mrp: parseFloat(row.mrp / 1.18).toFixed(2),
        rate_raw: rate,
        discount:
          isNaN(discount) || !Number.isFinite(discount) ? "-" : discount + "%",
        amount: (row.quantity * cost_price).toFixed(2),
        amount_raw: row.quantity * cost_price,
        image: row?.item_image ? (
          <img src={row?.item_image} alt="item" className={styles.itemImage} />
        ) : (
          <></>
        ),
      };
    });
  }, [dataSource]);

  const taxableAmount = React.useMemo(() => {
    let amount = 0;
    dataSource?.forEach((item) => {
      amount +=
        parseFloat(
          parseFloat(item?.unit_selling_price) +
            (parseFloat(item?.unit_selling_price) * parseFloat(item?.margin)) /
              100
        ) * parseFloat(item?.quantity);
    });
    return amount;
  }, [dataSource]);

  const totalAdditionalCharge = React.useMemo(() => {
    return additionalCharges?.reduce((acc, obj) => {
      return acc + obj.total ?? 0;
    }, 0);
  }, [additionalCharges]);

  const totalAmount = React.useMemo(() => {
    let amount = 0;
    dataSource?.forEach((item) => {
      amount +=
        parseFloat(item?.quantity) *
        ((parseFloat(item?.unit_selling_price) +
          parseFloat(item?.unit_selling_price) *
            (parseFloat(item?.margin) / 100)) *
          ((parseFloat(item?.tax_value) + 100) / 100));
      console.log("amount", item, amount);
    });
    return amount;
  }, [dataSource]);

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <div className={styles.titleBar}>
          <img
            src={organisationDetails?.organisation_logo}
            alt="MD for procurement"
            className={styles.logo}
          />
          <div className={styles.title}>
            <div>Pro Forma Invoice</div>
          </div>
        </div>
        <div className={styles.switchContainer}>
          <Space align="center">
            <Switch checked={showImage} onChange={setShowImage} />
            <span className={styles.switchLabel}>Show Image</span>
          </Space>
        </div>
        <section className={styles.source}>
          <div className={styles.sourceTitle}>{organisationDetails?.name}</div>
          <div className={styles.sourceAddress}>
            {currentGst?.address}{" "}
            {currentGst?.pincode ? `, ${currentGst?.pincode}` : ""}
          </div>
          <div className={styles.details}>
            <div>
              {generateDetail("Phone", currentGst?.contact)}
              {generateDetail("Email", currentGst?.email)}
              {generateDetail("GSTIN", currentGst?.gst_no)}
              {generateDetail("PAN", currentGst?.pan_no)}
            </div>
            <div>
              {generateDetail("Dated", new Date().toLocaleDateString(), true)}
              {generateDetail("Lead ID", null, true)}
              {generateDetail("Client ID", projectDetails?.project_name, true)}
              {generateDetail(
                "Sales Person",
                user?.name + ", " + user?.contact,
                true
              )}
            </div>
          </div>
        </section>
        <section className={styles.billTo}>
          {billTo && (
            <div>
              <div className={styles.sectionTitle}>Bill To</div>
              <div className={styles.sectionContent}>
                <div className={styles.billToTitle}>{billTo?.label}</div>
                <div className={styles.billToAddress}>
                  {billTo?.address}, {billTo?.city} - {billTo?.pincode}
                </div>
                <div className={styles.details}>
                  {generateDetail("Contact Person", billTo?.contact_person)}
                  {generateDetail("Phone", billTo?.contact_phone)}
                  {generateDetail("Email", billTo?.contact_email)}
                  {generateDetail("GSTIN", billTo?.gst_no)}
                  {generateDetail("PAN", billTo?.pan_no)}
                </div>
              </div>
            </div>
          )}
          {shipTo && (
            <div>
              <div className={styles.sectionTitle}>Ship To</div>
              <div className={styles.sectionContent}>
                <div className={styles.billToTitle}>{shipTo?.label}</div>
                <div className={styles.billToAddress}>
                  {shipTo?.address} {shipTo?.city} {shipTo?.pincode}
                </div>
                <div className={styles.details}>
                  {generateDetail("Contact Person", shipTo?.contact_person)}
                  {generateDetail("Phone", shipTo?.contact_phone)}
                  {generateDetail("GSTIN", shipTo?.gst_no)}
                </div>
              </div>
            </div>
          )}
        </section>
      </header>
      <main className={styles.main}>
        <table cellSpacing={0} cellPadding={0}>
          <thead>
            <tr>
              {visibleColumns?.map((col, idx) => (
                <th key={idx} className={styles[`col_${COL_MAP[col]}`]}>
                  {col}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {processedDataSource?.map((row, idx) => (
              <tr key={idx}>
                {visibleColumns?.map((col, idx) => (
                  <td key={idx} className={styles[`col_${COL_MAP[col]}`]}>
                    {row[COL_MAP[col]] ?? "-"}
                  </td>
                ))}
              </tr>
            ))}
            {/* Sub total row */}
            <tr className={styles.subtotal}>
              {visibleColumns?.map((col, idx) => {
                const column = COL_MAP[col];
                if (
                  ["idx", "hsn_code", "mrp", "brand", "image"].includes(column)
                ) {
                  return <td key={idx} className={styles[`col_${column}`]} />;
                }

                if (column === "boq_item") {
                  return (
                    <td key={idx} className={styles[`col_${column}`]}>
                      Sub Total
                    </td>
                  );
                }

                if (column === "quantity") {
                  return (
                    <td key={idx} className={styles[`col_${column}`]}>
                      {processedDataSource
                        ?.reduce((acc, cur) => {
                          return acc + parseFloat(cur?.quantity_raw);
                        }, 0)
                        ?.toFixed(2)}
                    </td>
                  );
                }

                // if (column === "rate") {
                //   return (
                //     <td key={idx} className={styles[`col_${column}`]}>
                //       {processedDataSource
                //         .reduce((acc, cur) => {
                //           return acc + parseFloat(cur?.rate_raw);
                //         }, 0)
                //         ?.toFixed(2)}
                //     </td>
                //   );
                // }

                // if (column === "amount") {
                //   return (
                //     <td key={idx} className={styles[`col_${column}`]}>
                //       {processedDataSource
                //         .reduce((acc, cur) => {
                //           return acc + parseFloat(cur?.amount_raw);
                //         }, 0)
                //         ?.toFixed(2)}
                //     </td>
                //   );
                // }
              })}
            </tr>
          </tbody>
        </table>
      </main>
      <footer className={styles.footer}>
        <div className={styles.details}>
          <div className={styles.sectionTitle}>Banking Details</div>
          <div className={styles.sectionContent}>
            {generateDetail("Bank Name", branch?.bank_name)}
            {generateDetail("Account Number", branch?.bank_account_number)}
            {generateDetail("IFSC Code", branch?.bank_ifsc)}
            {generateDetail("UPI ID", branch?.branch_upi)}
          </div>
          <div
            className={styles.sectionTitle}
            style={{
              marginTop: 15,
            }}
          >
            Payment Terms
          </div>
          <div className={styles.sectionContent}>
            {paymentTerms?.map((term, idx) => (
              <div key={idx}>
                {generateDetail(term.term, `${term.percentage}%`)}
              </div>
            ))}
          </div>
        </div>
        <div className={styles.amountBreakdown}>
          <div className="d-flex justify-content-between">
            <div className={styles.label}>Taxable Amount</div>
            <div className={styles.value}>
              ₹ {Number(taxableAmount).toFixed(2)}
            </div>
          </div>
          <TaxAmount
            items={dataSource}
            labelClass={styles.label}
            valueClass={styles.value}
          />
          {additionalCharges?.map((charge, idx) => (
            <div key={idx} className="d-flex justify-content-between">
              <div className={styles.label}>{charge.charge_type}</div>
              <div className={styles.value}>
                ₹ {Number(charge.total).toFixed(2)}
              </div>
            </div>
          ))}
          <div className={`d-flex justify-content-between ${styles.total}`}>
            <div className={styles.label}>Total Amount</div>
            <div className={styles.value}>
              ₹ {(totalAmount + totalAdditionalCharge).toFixed(2)}
            </div>
          </div>
        </div>
        <div className={styles.divider} />

        <div className={styles.signature}>
          <div className={styles.sectionTitle}>Authorised Signatory</div>
          <div className={styles.sectionContent}>
            {organisationDetails?.name}
          </div>
        </div>
        <div></div>
        <div className={styles.divider} />

        <div className={styles.generalTerms}>
          <div className={styles.sectionTitle}>General Terms</div>

          <div className={styles.sectionContent}>{terms}</div>
        </div>
      </footer>
    </div>
  );
};
